(function () {
  const heartIcon = '<svg class="iconsvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>';

  const RecentlyViewed = {
    key: 'branzos_recently_viewed',
    max: 8,
    section: document.querySelector('[data-recently-viewed-section]'),

    init() {
      if (!this.section) return;
      const current = this.section.dataset.handle;
      if (current) this.record(current);
      this.render(current);
    },

    get() {
      try {
        return JSON.parse(localStorage.getItem(this.key) || '[]');
      } catch {
        return [];
      }
    },

    record(handle) {
      let items = this.get();
      items = items.filter((h) => h !== handle);
      items.unshift(handle);
      items = items.slice(0, this.max);
      localStorage.setItem(this.key, JSON.stringify(items));
    },

    async render(current) {
      const grid = this.section.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;
      const handles = this.get().filter((h) => h !== current);
      if (handles.length < 2) {
        this.section.style.display = 'none';
        return;
      }

      const products = await Promise.all(
        handles.map((handle) =>
          fetch(`/products/${handle}.js`)
            .then((res) => res.json())
            .catch(() => null)
        )
      );

      const items = products.filter(Boolean).slice(0, 4);
      if (!items.length) {
        this.section.style.display = 'none';
        return;
      }

      grid.innerHTML = items.map((p) => {
        const variant = p.variants[0];
        const img = p.images && p.images[0]
          ? `<img class="product-card__image" loading="lazy" src="${p.images[0].split('?')[0]}?width=600&height=600&crop=center" alt="${p.title}">`
          : `<span class="product-card__image product-card__image--placeholder">🍬</span>`;
        const onSale = variant.compare_at_price > variant.price;
        return `
          <div class="product-card reveal is-visible">
            <a class="product-card__media" href="/products/${p.handle}">
              ${img}
            </a>
            <div class="product-card__actions">
              <button class="card-icon-btn wishlist-btn" data-wishlist-btn data-wishlist-handle="${p.handle}" aria-label="Add to wishlist">
                ${heartIcon}
              </button>
            </div>
            <div class="product-card__info">
              <h3 class="product-card__name"><a href="/products/${p.handle}">${p.title}</a></h3>
              <span class="price ${onSale ? 'price--sale' : ''}">
                <span class="price__current">${window.ShopifyTheme.money(variant.price)}</span>
              </span>
            </div>
          </div>`;
      }).join('');
    },
  };

  window.ShopifyRecentlyViewed = RecentlyViewed;
  Branzos.onLoad(() => RecentlyViewed.init());
})();
